import { aiApiClient } from "@src/api/ai-api";

/**
 * Emit a session event to the AI server (`POST /events/sessions/:sessionId`).
 * A generic, source-agnostic signal about a chat session that is NOT an LLM
 * turn (e.g. the user saved or discarded their changes). Best-effort: the
 * server acks immediately and fans the event out to the session's extensions.
 */
export const postSessionEvent = async (
  sessionId: string,
  type: string,
  payload?: Record<string, unknown>
): Promise<void> => {
  await aiApiClient.post(`/events/sessions/${sessionId}`, { type, payload });
};
